import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';

import {
    ZERO_X,
    CONTRACT_ADDRESS_256,
    CONTRACT_ADDRESS_64,
    BLOCK_NUMBER,
} from '../constants.js';
import gameContract from '../data/gameContract.js';
import Tiles from './Tiles';
import InfoBox from './InfoBox';
import './PastBoard.css';

export default class PastBoard extends Component {
    constructor(props) {
        super(props);
        const sideLength = Math.sqrt(Number(props.match.params.dimension));

        this.state = {
            tiles: Array(sideLength).fill().map(x => Array(sideLength).fill({
                address: ZERO_X,
                isClaimed: false,
                isLoading: false,
            })),
            sideLength,
            winningX: null,
            winningY: null,
            errorFetching: false,
        }
    }

    componentDidMount() {
        if (this.props.web3 && this.props.hasMetaMask) {
            this.getTiles(this.props.web3);
            this.getWinCoords(this.props.web3);
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.web3 && newProps.hasMetaMask) {
            this.getTiles(newProps.web3);
            this.getWinCoords(newProps.web3);
        }
    }

    getTiles(web3) {
        const { sideLength, tiles } = this.state;
        const contractAddress = sideLength === 8 ? CONTRACT_ADDRESS_64 : CONTRACT_ADDRESS_256;
        if (web3) {
            const gameNumber = Number(this.props.match.params.gameNumber);
            const contract = web3.eth.contract(gameContract.abi).at(contractAddress);
            const claimEvent = contract.TileClaimed(
                { gameNumber },
                {
                    fromBlock: BLOCK_NUMBER  - 1000,
                    toBlock: 'latest',
                }
            );
            claimEvent.get((error, results) => {
                if (error) {
                    this.setState(() => ({ errorFetching: true }))
                } else {
                    if (results == null || results.length !== sideLength**2) {
                        this.setState(() => ({ errorFetching: true }));
                        return;
                    }
                    results.forEach((event) => {
                        if (event.args.xCoord && event.args.yCoord && event.args.claimedBy) {
                            const xCoord = event.args.xCoord.toNumber();
                            const yCoord = event.args.yCoord.toNumber();
                            tiles[xCoord][yCoord] = {
                                address: event.args.claimedBy,
                                isClaimed: true,
                                isLoading: false,
                            };
                        }
                    });
                    this.setState((state, props) => ({
                        tiles,
                    }));
                }
            });
        }
    }

    getWinCoords(web3) {
        const { sideLength } = this.state;
        const contractAddress = sideLength === 8 ? CONTRACT_ADDRESS_64 : CONTRACT_ADDRESS_256;
        const gameNumber = Number(this.props.match.params.gameNumber);
        if (web3) {
            const contract = web3.eth.contract(gameContract.abi).at(contractAddress);
            const winEvent = contract.GameWon(
                // Setting a really old fromBlock works, but not if i use the actual block that
                // the contract was created...weird..should work with BLOCK_NUMBER but doesn't.
                { gameNumber },
                {
                    fromBlock: BLOCK_NUMBER - 1000,
                    toBlock: 'latest',
                }
            );
            winEvent.get((error, results) => {
                if (error) {
                    this.setState(() => ({ errorFetching: true }));
                } else {
                    if (results == null || results.length === 0) {
                        this.setState(() => ({ errorFetching: true }));
                        return;
                    }
                    const blockNumber = results[0].blockNumber;
                    web3.eth.getBlock(blockNumber - 1, (err, previousBlock) => {
                        const winningHash = previousBlock.hash;
                        if (results.length > 0) {
                            const winningX = sideLength === 8
                                ? parseInt(winningHash[winningHash.length - 1], 16) % 8
                                : parseInt(winningHash[winningHash.length - 1], 16);
                            const winningY = sideLength === 8
                                ? parseInt(winningHash[winningHash.length - 2], 16) % 8
                                : parseInt(winningHash[winningHash.length - 2], 16);
                            this.setState((state, props) => ({
                                winningX,
                                winningY
                            }));
                        }
                    });
                }
            });
        }
    }

    render() {
        const { tiles, errorFetching, sideLength, winningX, winningY } = this.state;
        const gameNumber = Number(this.props.match.params.gameNumber);
        const metaMaskMessage = (
            <p>
                You must have <a href="https://metamask.io" target="_blank"> MetaMask </a>
                installed to see previous boards.
            </p>
        );
        const errorMessage = (
            <p>
                Couldn't fetch winning board state for game {gameNumber}
            </p>
        );
        if (!this.props.hasMetaMask || errorFetching) {
            return (
                <div className="container">
                    <div className="header-bar">
                        <h1 className="game-title"> Hash Heroes </h1>
                        <Link className="hash-link" to="/winners">Back to winners</Link>
                    </div>
                    <h3 className="list-title"> {`Winning Board for ${sideLength}x${sideLength} Game ${gameNumber}`} </h3>
                    <div className="past-board">
                        <InfoBox>
                            {errorFetching ? errorMessage : metaMaskMessage}
                        </InfoBox>
                        <Tiles tiles={this.state.tiles} isDisabled={true} />
                    </div>
                </div>
            )
        } else {
            return <div className="container">
                <div className="header-bar">
                    <h1 className="game-title"> Hash Heroes </h1>
                    <Link className="hash-link" to="/winners">Back to winners</Link>
                </div>
                <h3 className="list-title"> {`Winning Board for ${sideLength}x${sideLength} Game ${gameNumber}`} </h3>
                <div className="past-board">
                    <Tiles tiles={tiles} isDisabled={true} winningX={winningX} winningY={winningY} />
                </div>
            </div>
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/PastBoard.js